export default {
  pathName: '', // 路由
  currDbSource: {}, // 当前数据源
  currJobData: {}, // 当前元数据
  DbSource: [], // 所有数据源，供元数据界面下拉列表使用
  selectJobMeta: {}, // 当前选择的元数据（搜索后点击的单条数据）
  specialSubject: [], // 专题数据（多条）
  duplicateJobMeta: {}, // 复制的数据
  lang:'CN',
  phLogoImage:'',
  themeColor:'',
  arrowIcon:'',
  nav_text_color:'',
  brand:'',
  compare: {
    attrs: [
      {
        value: -2,
        label: '产品型号'
      },
      {
        value: -1,
        label: '分类'
      },
    ],
    products: [],
    category_id: ''
  }
};